var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FrForwardModalContent',{attrs:{"description-text":_vm.$t('governance.requestModal.forward.description'),"comment-label":_vm.$t('governance.certificationTask.actionsModal.comment')},on:{"request-comment":_vm.updateComment,"request-update-actors":_vm.updateActors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }